import React from "react";
import { Link } from "react-router-dom";
import { Tooltip as ReactTooltip } from "react-tooltip";
import {
  FaLock,
  FaRegTrashAlt,
  FaPen,
  FaEye,
  FaKey,
  FaUserLock,
  FaSyncAlt,
  FaEnvelope,
  FaUserCheck,
  FaCalendarCheck,
  FaCopy,
  FaClone,
  FaUser,
  FaArchive,
  FaCheckSquare,
  FaComments,
  FaRegPlayCircle,
  FaRedoAlt,
  FaHourglassStart,
  FaCogs,
  FaDownload,
  FaUpload,
  FaTelegramPlane,
  FaSpinner
} from "react-icons/fa";
import { LiaQuora } from "react-icons/lia";
import { BiSolidFileDoc } from "react-icons/bi";
import style from "../../../../assets/scss/custom.module.scss";
import { getLoginAsUserNameFromLocalStorage } from "../../../loginasuser/LoginAsUser";

const TableActionBtnGroup = ({
  loginUser,
  user,
  viewUser,
  editUrl,
  buttonUrl,
  editBtn,
  changePassword,
  deactivateUser,
  activateUser,
  reSend,
  reStore,
  arChive,
  arChived,
  onRefresh,
  onDelete,
  email,
  calender,
  copyBtn,
  deFault,
  setAsDefault,
  duplicateBtn,
  comment,
  video,
  toggleVideo,
  quote,
  quoteLoading,
  setting,
  download,
  downloadLoading,
  upload,
  message,
  fnBtn,
  popDownload,
  popDownloadLoading,
  tooltips = {}
}) => {
  const isLoginAsUserActive = !getLoginAsUserNameFromLocalStorage();

  return (
    <>
      <ul className={style.actionButtonList}>
        <li>
          {isLoginAsUserActive && loginUser && (
            <button
              onClick={loginUser}
              type="button"
              className="login btn-action btn-primary"
              data-tooltip-id={tooltips.loginUser?.id}
            >
              <FaLock />
            </button>
          )}

          {fnBtn && (
            <button
              onClick={fnBtn}
              type="button"
              className="fnBtn btn-action btn-primary"
              data-tooltip-id={tooltips.fnBtn?.id}
            >
              {fn}
            </button>
          )}

          {editBtn && (
            <button
              onClick={editBtn}
              className="edit btn-action btn-primary"
              data-tooltip-id={tooltips.editBtn?.id}
            >
              <FaPen />
            </button>
          )}

          {copyBtn && (
            <button
              onClick={copyBtn}
              className="edit btn-action btn-primary"
              data-tooltip-id={tooltips.copyBtn?.id}
            >
              <FaCopy />
            </button>
          )}

          {duplicateBtn && (
            <button
              onClick={duplicateBtn}
              className="edit btn-action btn-primary"
              data-tooltip-id={tooltips.duplicateBtn?.id}
            >
              <FaClone />
            </button>
          )}
          {user && (
            <button
              onClick={user}
              type="button"
              className="login btn-action btn-primary"
              data-tooltip-id={tooltips.user?.id}
            >
              <FaUser />
            </button>
          )}

          {email && (
            <button
              type="button"
              className="btn-action btn-primary"
              data-tooltip-id={tooltips.email?.id}
              onClick={email}
            >
              <FaEnvelope />
            </button>
          )}

          {editUrl && (
            <Link
              to={editUrl}
              className="edit btn-action btn-primary"
              data-tooltip-id={tooltips.editUrl?.id}
            >
              <FaPen />
            </Link>
          )}

          {buttonUrl && (
            <button
              onClick={buttonUrl}
              className="edit btn-action btn-primary"
              data-tooltip-id={tooltips.buttonUrl?.id}
            >
              <FaPen />
            </button>
          )}

          {changePassword && (
            <button
              onClick={changePassword}
              type="button"
              className="btn-action btn-primary"
              data-tooltip-id={tooltips.changePassword?.id}
            >
              <FaKey />
            </button>
          )}

          {deactivateUser && (
            <button
              onClick={deactivateUser}
              type="button"
              className="btn-action btn-primary"
              data-tooltip-id={tooltips.deactivateUser?.id}
            >
              <FaUserLock />
            </button>
          )}

          {activateUser && (
            <button
              onClick={activateUser}
              type="button"
              className="btn-action btn-primary"
              data-tooltip-id={tooltips.activateUser?.id}
            >
              <FaUserCheck />
            </button>
          )}

          {reSend && (
            <button
              type="button"
              className="btn-action btn-primary"
              data-tooltip-id={tooltips.reSend?.id}
              onClick={reSend}
            >
              <FaEnvelope />
            </button>
          )}

          {calender && (
            <button
              type="button"
              className="btn-action btn-primary"
              data-tooltip-id={tooltips.calender?.id}
              onClick={calender}
            >
              <FaCalendarCheck />
            </button>
          )}

          {reStore && (
            <button
              type="button"
              className="restore btn-action btn-primary"
              data-tooltip-id={tooltips.reStore?.id}
              onClick={reStore}
            >
              <FaSyncAlt />
            </button>
          )}

          {arChive && (
            <button
              type="button"
              className="restore btn-action btn-primary"
              data-tooltip-id={tooltips.arChive?.id}
              onClick={arChive}
            >
              <FaArchive />
            </button>
          )}

          {arChived && (
            <button
              type="button"
              className={`${style.archivedBtnDisabled} restore btn-action hoverBgblack`}
              data-tooltip-id={tooltips.arChived?.id}
              onClick={arChived}
              disabled={!!arChived}
            >
              <FaArchive />
            </button>
          )}

          {deFault && (
            <button
              type="button"
              className="restore btn-action btn-primary"
              data-tooltip-id={tooltips.deFault?.id}
              onClick={deFault}
            >
              <FaCheckSquare />
            </button>
          )}
          {setAsDefault && (
            <button
              type="button"
              className="restore btn-action btn-primary"
              data-tooltip-id={tooltips.setAsDefault?.id}
              onClick={setAsDefault}
            >
              <FaHourglassStart />
            </button>
          )}

          {comment && (
            <button
              type="button"
              className="comment btn-action btn-primary"
              data-tooltip-id={tooltips.comment?.id}
              onClick={comment}
            >
              <FaComments />
            </button>
          )}

          {video && (
            <button
              type="button"
              className="video btn-action btn-primary"
              data-tooltip-id={tooltips.video?.id}
              onClick={video}
            >
              <FaRegPlayCircle />
            </button>
          )}

          {toggleVideo && (
            <button
              type="button"
              className="toggleVideo btn-action btn-primary"
              data-tooltip-id={tooltips.toggleVideo?.id}
              onClick={toggleVideo.onClick}
            >
              {toggleVideo.icon}
            </button>
          )}

          {onRefresh && (
            <button
              type="button"
              className="refresh btn-action btn-primary"
              data-tooltip-id={tooltips.onRefresh?.id}
              onClick={onRefresh}
            >
              <FaRedoAlt />
            </button>
          )}

          {quote && (
            <button
              type="button"
              className="quote btn-action btn-primary"
              data-tooltip-id={tooltips.quote?.id}
              onClick={quote}
              disabled={quoteLoading}
            >
              {quoteLoading ? (
                <FaSpinner className="spin-load" />
              ) : (
                <LiaQuora />
              )}
            </button>
          )}

          {viewUser && (
            <button
              onClick={viewUser}
              type="button"
              className="btn-action btn-primary"
              data-tooltip-id={tooltips.viewUser?.id}
            >
              <FaEye />
            </button>
          )}

          {popDownload && (
            <button
              onClick={popDownload}
              type="button"
              className="btn-action btn-primary"
              data-tooltip-id={tooltips.popDownload?.id}
              disabled={popDownloadLoading}
            >
              {popDownloadLoading ? (
                <FaSpinner className="spin-load" />
              ) : (
                <BiSolidFileDoc />
              )}
            </button>
          )}

          {setting && (
            <button
              type="button"
              className="setting btn-action btn-primary"
              data-tooltip-id={tooltips.setting?.id}
              onClick={setting}
            >
              <FaCogs />
            </button>
          )}

          {download && (
            <button
              type="button"
              className="download btn-action btn-primary"
              data-tooltip-id={tooltips.download?.id}
              onClick={download}
            >
              {downloadLoading ? (
                <FaSpinner className="spin-load" />
              ) : (
                <FaDownload />
              )}
            </button>
          )}

          {upload && (
            <button
              type="button"
              className="upload btn-action btn-primary"
              data-tooltip-id={tooltips.upload?.id}
              onClick={upload}
            >
              <FaUpload />
            </button>
          )}

          {message && (
            <button
              type="button"
              className="upload btn-action btn-primary"
              data-tooltip-id={tooltips.message?.id}
              onClick={message}
            >
              <FaTelegramPlane />
            </button>
          )}
          {onDelete && (
            <button
              type="button"
              className="delete btn-action btn-primary red-bg"
              data-tooltip-id={tooltips.onDelete?.id}
              onClick={onDelete}
            >
              <FaRegTrashAlt />
            </button>
          )}
        </li>
      </ul>

      {Object.keys(tooltips).map((key) => (
        <ReactTooltip
          key={tooltips[key].id}
          id={tooltips[key].id}
          place={tooltips[key].place}
          content={tooltips[key].content}
          className="tooltipcustom"
        />
      ))}
    </>
  );
};

import PropTypes from "prop-types";
import { fn } from "../../../../locales/en";

TableActionBtnGroup.propTypes = {
  loginUser: PropTypes.func,
  user: PropTypes.func,
  viewUser: PropTypes.func,
  editUrl: PropTypes.string,
  buttonUrl: PropTypes.func,
  editBtn: PropTypes.func,
  changePassword: PropTypes.func,
  deactivateUser: PropTypes.func,
  activateUser: PropTypes.func,
  reSend: PropTypes.func,
  reStore: PropTypes.func,
  arChive: PropTypes.func,
  arChived: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onRefresh: PropTypes.func,
  onDelete: PropTypes.func,
  email: PropTypes.func,
  calender: PropTypes.func,
  copyBtn: PropTypes.func,
  deFault: PropTypes.func,
  setAsDefault: PropTypes.func,
  duplicateBtn: PropTypes.func,
  comment: PropTypes.func,
  video: PropTypes.func,
  toggleVideo: PropTypes.shape({
    onClick: PropTypes.func,
    icon: PropTypes.node
  }),
  quote: PropTypes.func,
  quoteLoading: PropTypes.bool,
  setting: PropTypes.func,
  download: PropTypes.func,
  downloadLoading: PropTypes.bool,
  upload: PropTypes.func,
  message: PropTypes.func,
  tooltips: PropTypes.object,
  fnBtn: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
  popDownload: PropTypes.func,
  popDownloadLoading: PropTypes.bool
};

export default TableActionBtnGroup;
